import React, { useState } from "react";
import { motion } from "framer-motion";
import "./AdminPasswordProtection.css";

const AdminPasswordProtection = ({ onAuthenticated }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    // Admin authentication check
    const adminUsername = process.env.REACT_APP_ADMIN_USERNAME || "lvs";
    const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD || "lvs";
    
    if (username === adminUsername && password === adminPassword) {
      setTimeout(() => {
        onAuthenticated();
        setIsLoading(false);
      }, 1000);
    } else {
      setTimeout(() => {
        setError("نام کاربری یا رمز عبور مدیریت اشتباه است");
        setIsLoading(false);
      }, 1000);
    }
  };

  return (
    <div className="admin-password-protection">
      <div className="admin-password-overlay">
        <motion.div
          className="admin-password-container"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <motion.div
            className="admin-password-header"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h1 className="admin-site-title">LAVVISSA</h1>
            <p className="admin-subtitle">پنل مدیریت</p>
          </motion.div>

          <motion.form
            className="admin-password-form"
            onSubmit={handleSubmit}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <div className="admin-input-group">
              <input
                type="text"
                placeholder="نام کاربری مدیر"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="admin-password-input"
                required
              />
            </div>

            <div className="admin-input-group">
              <input
                type="password"
                placeholder="رمز عبور مدیر"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="admin-password-input"
                required
              />
            </div>

            {error && (
              <motion.div
                className="admin-error-message"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.3 }}
              >
                {error}
              </motion.div>
            )}

            <motion.button
              type="submit"
              className="admin-password-submit"
              disabled={isLoading}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {isLoading ? (
                <div className="admin-loading-spinner"></div>
              ) : (
                "ورود به پنل مدیریت"
              )}
            </motion.button>
          </motion.form>

          <motion.div
            className="admin-password-footer"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.8 }}
          >
            <p>دسترسی محدود به مدیران سیستم</p>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default AdminPasswordProtection;
